import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";

import ReactTooltip from "react-tooltip";

import './SpeciesChooser.scss'

import Dog from "./../../../svg/dog.svg";
import Cat from "./../../../svg/cat.svg";
import Rabbit from "./../../../svg/rabbit.svg";
import Hamster from "./../../../svg/hamster.svg";

const initState = {
  dog: false,
  cat: false,
  rabbit: false,
  ginnypig: false,
  none: false
}

export const SpeciesChooser = ({species, handleSpeciesChange}) => {

  const [choice, setChoice] = useState(initState);

  useEffect(() => {
    setChoice({...choice, [species]: true})
  }, [])

  const handleChoice = value => {
    setChoice({...initState, [value]: true});
    handleSpeciesChange(value)
  };

  return (
    <>
    <h2>Tierart</h2>
    <div className="speciesChooser__wrapper">
      <Button
      className={`speciesChooser__button ${choice.dog ? 'speciesChooser__button--active' : ''}`}
      onClick={() => handleChoice("dog")}
      data-tip="Hund" data-for="tooltip"
      >
        <Dog />
      </Button>
      <Button
      className={`speciesChooser__button ${choice.cat ? 'speciesChooser__button--active' : ''}`}
      onClick={() => handleChoice("cat")}
      data-tip="Katze" data-for="tooltip"
      >
        <Cat />
      </Button>
      <Button
      className={`speciesChooser__button ${choice.rabbit ? 'speciesChooser__button--active' : ''}`}
      onClick={() => handleChoice("rabbit")}
      data-tip="Kaninchen" data-for="tooltip"
      >
        <Rabbit />
      </Button>
      <Button
      className={`speciesChooser__button ${choice.ginnypig ? 'speciesChooser__button--active' : ''}`}
      onClick={() => handleChoice("ginnypig")}
      data-tip="Meerschweinchen" data-for="tooltip"
      >
        <Hamster />
      </Button>

      <ReactTooltip id="tooltip" className="tooltip" getContent={(dataTip) => dataTip} type="dark" place="top" effect="solid"/>
    </div>
    </>
  );
};
